import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import t from "@zendesk/client-i18n-tools";

import {
  SelectField,
  Label,
  Hint,
  Select,
  Item,
} from "@zendeskgarden/react-select";

const frequencies = [
  "TWO_WEEKS",
  "ONE_MONTH",
  "THREE_MONTHS",
  "SIX_MONTHS",
  "ONE_YEAR",
];

export default class FrequencyStep extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    selectedKey: PropTypes.oneOf(frequencies).isRequired,
  };

  static defaultProps = {
    selectedKey: frequencies[0],
  };

  render() {
    const { onChange, selectedKey } = this.props;

    return (
      <SelectField>
        <Label>{t("knowledge-verification.frequency.label")}</Label>
        <Hint>{t("knowledge-verification.frequency.hint")}</Hint>
        <Select
          data-test-id="frequency-select"
          selectedKey={selectedKey}
          onChange={onChange}
          options={frequencies.map(frequency => (
            <Item key={frequency}>
              {t(`knowledge-verification.frequency.${frequency}`)}
            </Item>
          ))}
        >
          {t(`knowledge-verification.frequency.${selectedKey}`)}
        </Select>
      </SelectField>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FrequencyField/index.js